import { FC, useState } from 'react';
import { twMerge } from 'tailwind-merge';

import { SharePlanType } from '../../../types/pool-plans.types';
import { AppFormattedMessage } from '../../app-formatted-message/index';
import Button from '../../button/index';
import { useIntervalFromToday } from '../format-date.util';

type NotificationProps = {
  createdAt: Date;
  isRead: boolean;
  isTerminated?: boolean;
  message: string;
  onExercise: () => void;
  onMarkRead: () => void;
  onMarkResolved: () => void;
  planType: SharePlanType;
  resolved: boolean;
  type: string;
};

export const RequestNotification: FC<NotificationProps> = ({
  createdAt,
  isRead,
  message,
  resolved,
  onMarkRead,
  type,
  onExercise,
  onMarkResolved,
  planType,
  isTerminated,
}) => {
  const [read, setRead] = useState(false);
  const [isResolved, setResolved] = useState(false);
  const date = useIntervalFromToday(createdAt);

  if (resolved || isResolved) return null;
  return (
    <div
      className={twMerge(
        'flex flex-col gap-4 rounded-lg border border-brand-50 bg-brand-25 px-4 py-3',
        (isRead || read) && 'border-gray-200 bg-white',
      )}
    >
      <div className="flex w-full justify-between text-label-md font-medium text-gray-500">
        <span>{type}</span>
        <span>{date}</span>
      </div>
      <div className="flex w-full gap-3">
        <div className="size-10 shrink-0 rounded-full bg-brand-700" />
        <div className="flex w-full flex-col gap-4">
          <span className="text-sm font-[450] text-black">{message}</span>
          <div className="flex w-full gap-4 max-lg:flex-col lg:justify-between">
            {!(isRead || read) && (
              <>
                <Button
                  className="w-fit text-nowrap text-sm font-medium text-brand-700"
                  onClick={() => {
                    onMarkRead();
                    setRead(true);
                  }}
                  styleType="NONE"
                >
                  <AppFormattedMessage id="MARK_AS_READ" />
                </Button>
              </>
            )}

            {!(resolved || isResolved) && (
              <div
                className="flex h-9 w-full justify-end gap-2 text-sm font-[450] text-gray-700"
                data-permission-required
              >
                <Button
                  className="w-fit rounded border border-gray-100 bg-white px-3 shadow-xs"
                  data-permission-required
                  onClick={() => {
                    onMarkResolved();
                    setResolved(true);
                    onMarkRead();
                    setRead(true);
                  }}
                  styleType="NONE"
                >
                  <AppFormattedMessage id="MARK_AS_RESOLVED" />
                </Button>
                <Button
                  className="w-fit px-4 font-[550] text-white"
                  data-permission-required
                  onClick={onExercise}
                >
                  <AppFormattedMessage
                    id={
                      planType === SharePlanType.GROWTH_HURDLE
                        ? 'APPROVE'
                        : isTerminated
                          ? 'EXERCISE_RETURN'
                          : 'EXERCISE'
                    }
                  />
                </Button>
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};
